import { getUserId } from 'app/auth/selectors';
import { createScratchBranchMutation } from 'app/branches/api';
import { createRoutine } from 'app/common/utils/new-routines';
import { getRoutineSaga } from 'app/common/utils/new-sagas';
import { getProjectId } from 'app/schema';
import type { SagaIterator } from 'redux-saga';
import { all, call, select, takeLatest } from 'redux-saga/effects';

type EnsureScratchBranchAction = {
  name?: string;
};

export const ensureScratchBranchRoutine = createRoutine('branches/ENSURE_SCRATCH_BRANCH')<
  EnsureScratchBranchAction,
  undefined,
  undefined,
  undefined,
  string,
  undefined
>();

export function* ensureScratchBranchSaga(payload: undefined, { name }: EnsureScratchBranchAction = {}): SagaIterator {
  const userId = yield select(getUserId);
  const projectId = yield select(getProjectId);
  return yield call(createScratchBranchMutation, projectId, userId, name);
}

export default function* root(): SagaIterator {
  yield all([
    takeLatest(
      ensureScratchBranchRoutine.requested,
      getRoutineSaga(ensureScratchBranchRoutine, ensureScratchBranchSaga)
    )
  ]);
}
